import '../__generated__/styles/tabs.css';
import _extends from '@babel/runtime/helpers/esm/extends';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React, { useRef, useLayoutEffect, useState } from 'react';
import clsx from 'clsx';
import { useTheme } from '@paypalcorp/pp-react-theme';
import { IconButton } from '@paypalcorp/pp-react-icon-button';
import { V2ArrowLeftIcon, ChevronLeftIcon, V2ArrowRightIcon, ChevronRightIcon } from '@paypalcorp/pp-react-icons';
import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';

var styles = {"ppvx_tabs":"ppvx_tabs___2-8-10","ppvx_tabs__scroll-btn":"ppvx_tabs__scroll-btn___2-8-10","ppvx_tabs__scroll-btn-left":"ppvx_tabs__scroll-btn-left___2-8-10","ppvx_tabs__scroll-btn-right":"ppvx_tabs__scroll-btn-right___2-8-10","ppvx_tabs__nav":"ppvx_tabs__nav___2-8-10","ppvx_tabs__tabs-wrapper":"ppvx_tabs__tabs-wrapper___2-8-10","ppvx_tabs__tab":"ppvx_tabs__tab___2-8-10","ppvx_tabs--animate-right":"ppvx_tabs--animate-right___2-8-10","slideRight":"slideRight___2-8-10","ppvx_tabs--animate-left":"ppvx_tabs--animate-left___2-8-10","slideLeft":"slideLeft___2-8-10","ppvx_tabs__arrow":"ppvx_tabs__arrow___2-8-10","ppvx_tabs__arrow-left":"ppvx_tabs__arrow-left___2-8-10","ppvx_tabs__arrow-right":"ppvx_tabs__arrow-right___2-8-10","ppvx_tabs__tab-content":"ppvx_tabs__tab-content___2-8-10","ppvx_tabs__tab-content--focus":"ppvx_tabs__tab-content--focus___2-8-10","ppvx_tabs--centered":"ppvx_tabs--centered___2-8-10","ppvx_tabs--no-scroll-buttons":"ppvx_tabs--no-scroll-buttons___2-8-10","ppvx--v2":"ppvx--v2___2-8-10","ppvx--v1":"ppvx--v1___2-8-10","ppvx_tabs--arrow_icon":"ppvx_tabs--arrow_icon___2-8-10"};

var _excluded = ["id", "tabIdx", "label", "tabGroupId", "panelId", "selected", "animate", "onClick", "className"];

var Tab = function (_ref) {
  var id = _ref.id,
      tabIdx = _ref.tabIdx,
      label = _ref.label,
      tabGroupId = _ref.tabGroupId,
      panelId = _ref.panelId,
      selected = _ref.selected,
      animate = _ref.animate,
      onClick = _ref.onClick,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  var tabClasses = clsx(styles.ppvx_tabs__tab, _defineProperty({}, styles["ppvx_tabs--animate-".concat(animate)], animate), className);
  var focusable = selected ? 0 : -1;
  var tabId = id || "".concat(tabGroupId, "-tab").concat(parseInt(tabIdx, 10) + 1);
  return /*#__PURE__*/React.createElement("button", _extends({
    "data-tab-index": tabIdx,
    id: tabId,
    className: tabClasses,
    "aria-controls": panelId,
    "aria-selected": selected,
    tabIndex: focusable,
    type: "button",
    role: "tab"
  }, rest, {
    onClick: onClick,
    "data-button-text": label
  }), label);
};

var _excluded$1 = ["id", "panelId", "label"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var isRunningOnIEorEdge = function () {
  if (typeof navigator !== 'undefined' && (/MSIE 9/i.test(navigator.userAgent) || /MSIE 10/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent) || /Edge\/\d./i.test(navigator.userAgent))) {
    return true;
  }

  return false;
};

var getRefCurrent = function (myRef) {
  return (
    /* istanbul ignore next */
    myRef && myRef.current ? myRef.current : null
  );
}; // keycodes for handling keydown events


var LEFT_ARROW = 37;
var RIGHT_ARROW = 39;
var ENTER = 13;
var SPACE = 32; // for scrolling with transition

var SPEED = 25;
var DISTANCE = 120;
var STEP = 20; // eslint-disable-next-line max-statements

var Tabs = function (_ref) {
  var _clsx;

  var name = _ref.name,
      selectedTabIdx = _ref.selectedTabIdx,
      center = _ref.center,
      tabs = _ref.tabs,
      onClick = _ref.onClick,
      className = _ref.className,
      tabClassName = _ref.tabClassName,
      tabsWrapperClassName = _ref.tabsWrapperClassName,
      children = _ref.children,
      _ref$scrollLeftLabel = _ref.scrollLeftLabel,
      scrollLeftLabel = _ref$scrollLeftLabel === void 0 ? 'scroll left' : _ref$scrollLeftLabel,
      _ref$scrollRightLabel = _ref.scrollRightLabel,
      scrollRightLabel = _ref$scrollRightLabel === void 0 ? 'scroll right' : _ref$scrollRightLabel,
      theme = _ref.theme;

  var _theme = useTheme('Tabs', theme);

  var isThemeV2 = _theme && _theme === 'v2';

  if (_theme !== 'v2') {
    console.warn('Tabs 1.0 styles are deprecated. Use Tabs 2.0 styles and refer to our Migration Guide on how to use 2.0 styles/components.');
  }

  var navEleRef = useRef();
  var containerEleRef = useRef();
  var prevSelectedTabIdxRef = useRef(0);
  var isTabsFocusedRef = useRef(false);
  var focusedIdxRef = useRef();

  var getSelectedTabIdx = function () {
    var index = typeof selectedTabIdx === 'string' ? parseInt(selectedTabIdx, 10) : Math.floor(selectedTabIdx);

    if (!selectedTabIdx || !index || index >= tabs.length || index < 0) {
      return 0;
    }

    return index;
  };
  /* istanbul ignore next */


  var determineOverflow = function () {
    var nav = getRefCurrent(navEleRef);

    if (nav) {
      var tabsWrapper = nav.children[0];
      var _scroll = nav.scrollLeft;
      var navRight = Math.floor(nav.getBoundingClientRect().right);
      var tabsRight = Math.floor(tabsWrapper.getBoundingClientRect().right);
      var navLeft = Math.floor(nav.getBoundingClientRect().left);
      var tabsLeft = Math.floor(tabsWrapper.getBoundingClientRect().left) - tabsWrapper.offsetLeft;

      if (_scroll === 0 && navRight > tabsRight) {
        nav.setAttribute('data-overflowing', 'none');
        return;
      }

      if (tabsLeft < navLeft && navRight < tabsRight) {
        nav.setAttribute('data-overflowing', 'both');
        return;
      }

      if (_scroll === 0 && tabsRight > navRight) {
        nav.setAttribute('data-overflowing', 'right');
        return;
      }

      if (tabsLeft < navLeft) {
        nav.setAttribute('data-overflowing', 'left');
        return;
      }

      nav.setAttribute('data-overflowing', 'none');
    } // record that the function was called


    var evt = new Event('checkOverflow');
    window.dispatchEvent(evt);
  };

  var offsetFocus = function (offset) {
    var nav = getRefCurrent(navEleRef);
    var tabDomItems = nav.querySelectorAll('[role="tab"]');
    var nextIndex = focusedIdxRef.current + offset;
    var index;
    /* istanbul ignore next */

    if (nextIndex === tabs.length) {
      index = 0;
    } else if (nextIndex === -1) {
      index = tabs.length - 1;
    } else {
      index = nextIndex;
    }

    tabDomItems[index].focus();
    tabDomItems[index].scrollIntoView({
      block: 'nearest'
    });
    focusedIdxRef.current = index;
  };

  var keyHandler = function (event) {
    var keyCode = event.key || event.keyCode;
    var selectedIndex = getSelectedTabIdx();

    switch (keyCode) {
      case 'ArrowLeft':
      case 'Left':
      case LEFT_ARROW:
        event.preventDefault();
        offsetFocus(-1);
        break;

      case 'ArrowRight':
      case 'Right':
      case RIGHT_ARROW:
        event.preventDefault();
        offsetFocus(1);
        break;

      case 'Enter':
      case ENTER:
      case ' ':
      case SPACE:
        event.preventDefault();
        /* istanbul ignore next */

        if (selectedIndex !== focusedIdxRef.current) {
          onClick(event, focusedIdxRef.current);
        }

        break;
    }
  };

  var handleFocusOut = function (event) {
    isTabsFocusedRef.current = false;
    var newFocusedItem = event.relatedTarget;
    /* istanbul ignore next */

    if (!newFocusedItem || newFocusedItem.parentElement !== event.currentTarget) {
      // @ts-ignore
      document.removeEventListener('keydown', keyHandler, false); // reset focusedIdx to current selected tab

      focusedIdxRef.current = getSelectedTabIdx(); // add scroll arrows back when focus is out:

      determineOverflow();
    }
  };

  useLayoutEffect(function () {
    var nav = getRefCurrent(navEleRef);
    prevSelectedTabIdxRef.current = getSelectedTabIdx();
    /* istanbul ignore next */

    if (isTabsFocusedRef.current) {
      // @ts-ignore
      document.addEventListener('keydown', keyHandler, false);
    }

    nav.firstChild.addEventListener('focusout', // @ts-ignore
    handleFocusOut, false);
    return function () {
      // @ts-ignore
      document.removeEventListener('keydown', keyHandler, false);
      nav.firstChild.removeEventListener('focusout', // @ts-ignore
      handleFocusOut, false);
    };
  }, [tabs, selectedTabIdx, onClick]);
  useLayoutEffect(function () {
    var container = getRefCurrent(containerEleRef);
    var nav = getRefCurrent(navEleRef);
    var resizeObserver;
    focusedIdxRef.current = getSelectedTabIdx();
    var scrollButtons = container.querySelectorAll(".".concat(styles['ppvx_tabs__scroll-btn']));

    if (!isRunningOnIEorEdge()) {
      determineOverflow(); // Check for overflow after window resize:

      /* istanbul ignore next */

      if (window.ResizeObserver) {
        resizeObserver = new ResizeObserver(function () {
          determineOverflow();
        });
        resizeObserver.observe(nav);
      } // adjust left/right arrow buttons height tof the tabs wrapper.


      var tabsWrapper = nav.children[0];
      /* istanbul ignore next */

      var btnHeight = isThemeV2 ? (tabsWrapper.offsetHeight + tabsWrapper.offsetTop * 2).toString() : tabsWrapper.offsetHeight.toString();
      /* istanbul ignore next */

      if (scrollButtons && tabsWrapper.offsetHeight !== scrollButtons[0].offsetHeight) {
        scrollButtons[0].style.height = "".concat(btnHeight, "px");
        scrollButtons[1].style.height = "".concat(btnHeight, "px");
      }
    }

    return function () {
      /* istanbul ignore next */
      if (resizeObserver) {
        resizeObserver.disconnect();
      }
    };
  }, []);

  var handleClick = function (event) {
    var nav = getRefCurrent(navEleRef);
    var tabDomItems = nav.querySelectorAll('[role="tab"]');
    isTabsFocusedRef.current = false;
    /* istanbul ignore next */

    if (tabDomItems[focusedIdxRef.current]) {
      tabDomItems[focusedIdxRef.current].blur();
    }

    var tabIdxClicked = parseInt(event.currentTarget.getAttribute('data-tab-index'), 10); // This is tested, but coverage not registering it

    /* istanbul ignore next */

    if (tabIdxClicked) {
      focusedIdxRef.current = tabIdxClicked;
    }

    onClick(event, tabIdxClicked);
  };

  var handleFocus = function (event) {
    var nav = getRefCurrent(navEleRef);
    isTabsFocusedRef.current = true;
    var prevFocusedItem = event.relatedTarget;

    if (!prevFocusedItem || prevFocusedItem.parentElement !== event.currentTarget) {
      // @ts-ignore
      document.addEventListener('keydown', keyHandler, false); // remove arrows when navigating with keyboard:

      nav.setAttribute('data-overflowing', 'none');
    }
  };

  var handleTouchScroll = function () {
    var isScrolling;
    window.clearTimeout(isScrolling);
    /* istanbul ignore next */

    isScrolling = setTimeout(function () {
      determineOverflow();
    }, 15);
  };
  /* istanbul ignore next */


  var scroll = function (direction) {
    var nav = getRefCurrent(navEleRef); // scroll with transition

    var scrollAmount = 0;
    var slideTimer = window.setInterval(function () {
      if (direction === 'right') {
        nav.scrollLeft += STEP;
      } else {
        nav.scrollLeft -= STEP;
      }

      scrollAmount += STEP;

      if (scrollAmount >= DISTANCE) {
        window.clearInterval(slideTimer);
      }
    }, SPEED);
    setTimeout(function () {
      determineOverflow();
    }, 150); // record that scroll event was called

    var evt = new Event('tabsScrolled');
    window.dispatchEvent(evt);
  };

  var selectedIndex = getSelectedTabIdx();
  var tabsContainerClasses = clsx(styles.ppvx_tabs, (_clsx = {}, _defineProperty(_clsx, styles['ppvx--v2'], isThemeV2), _defineProperty(_clsx, styles['ppvx_tabs--no-scroll-buttons'], isRunningOnIEorEdge()), _clsx), className);
  var tabsWrapperClasses = clsx(styles['ppvx_tabs__tabs-wrapper'], _defineProperty({}, styles['ppvx_tabs--centered'], center), tabsWrapperClassName);
  var leftScrollBtnClass = clsx(styles['ppvx_tabs__scroll-btn'], styles['ppvx_tabs__scroll-btn-left']);
  var rightScrollBtnClass = clsx(styles['ppvx_tabs__scroll-btn'], styles['ppvx_tabs__scroll-btn-right']);
  var scrollButtonFocus = -1;
  var selectedId;
  var animateDirection;
  var tabItems = tabs.map(function (tab, idx1) {
    var id = tab.id,
        panelId = tab.panelId,
        label = tab.label,
        otherTabProps = _objectWithoutProperties(tab, _excluded$1); // update animation (only on the selected tab)


    if (idx1 === selectedIndex) {
      selectedId = tab.id || "".concat(name, "-tab").concat(idx1 + 1);

      if (prevSelectedTabIdxRef.current > idx1) {
        animateDirection = 'left';
      } else if (prevSelectedTabIdxRef.current < idx1) {
        animateDirection = 'right';
      }
    } else {
      animateDirection = null;
    }

    return /*#__PURE__*/React.createElement(Tab, _extends({
      key: "".concat(name, "-tab").concat(idx1 + 1),
      id: id,
      tabIdx: idx1.toString(),
      label: label,
      tabGroupId: name,
      panelId: panelId,
      selected: idx1 === selectedIndex,
      animate: animateDirection,
      onClick: handleClick,
      className: tabClassName
    }, otherTabProps));
  }); // Get selected tab panel

  var tabPanel = React.Children.toArray(children).filter(function (_panel, idx2) {
    return selectedIndex === idx2;
  })[0]; // Update selected tab panel props

  var tabContentItem = React.cloneElement(tabPanel, {
    tabId: selectedId,
    hidden: false
  });
  var classNameAttr = isThemeV2 && {
    className: styles['ppvx_tabs--arrow_icon']
  };

  var otherIconButtonAttr = _objectSpread(_objectSpread({}, isThemeV2 && {
    buttonType: 'tertiary'
  }), classNameAttr);

  return /*#__PURE__*/React.createElement("div", {
    ref: containerEleRef,
    id: name,
    className: tabsContainerClasses
  }, /*#__PURE__*/React.createElement("nav", {
    className: styles.ppvx_tabs__nav,
    "data-overflowing": "right",
    id: "".concat(name, "-nav"),
    ref: navEleRef,
    onScroll: function onScroll() {
      return handleTouchScroll();
    }
  }, /*#__PURE__*/React.createElement("div", {
    id: "".concat(name, "-tabs"),
    className: tabsWrapperClasses,
    role: "tablist",
    onFocus: function onFocus(e) {
      return handleFocus(e);
    },
    onMouseDown: function onMouseDown(e) {
      return e.preventDefault();
    } //remove focus on click

  }, tabItems)), /*#__PURE__*/React.createElement("span", {
    className: leftScrollBtnClass
  }, /*#__PURE__*/React.createElement(IconButton, _extends({
    svgIconComponent: isThemeV2 ? V2ArrowLeftIcon : ChevronLeftIcon,
    "aria-label": scrollLeftLabel,
    tabIndex: scrollButtonFocus,
    theme: _theme,
    onClick: function () {
      return scroll('left');
    }
  }, otherIconButtonAttr), scrollLeftLabel)), /*#__PURE__*/React.createElement("span", {
    className: rightScrollBtnClass
  }, /*#__PURE__*/React.createElement(IconButton, _extends({
    svgIconComponent: isThemeV2 ? V2ArrowRightIcon : ChevronRightIcon,
    tabIndex: scrollButtonFocus,
    theme: _theme,
    onClick: function () {
      return scroll('right');
    }
  }, otherIconButtonAttr), scrollRightLabel)), tabContentItem);
};

var _excluded$2 = ["id", "tabId", "hidden", "className", "children"];

var TabPanel = function (_ref) {
  var id = _ref.id,
      tabId = _ref.tabId,
      hidden = _ref.hidden,
      className = _ref.className,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded$2);

  var hasMouseClickFocus = useRef(false);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      mouseFocus = _useState2[0],
      updateMouseFocus = _useState2[1];

  var tabPanelClasses = clsx(className, styles['ppvx_tabs__tab-content'], _defineProperty({}, styles['ppvx_tabs__tab-content--focus'], !mouseFocus)); //to prevent tab panel from getting focus on mouse-click

  return /*#__PURE__*/React.createElement("div", _extends({
    id: id,
    className: tabPanelClasses,
    "aria-labelledby": tabId,
    "aria-hidden": hidden,
    tabIndex: 0,
    role: "tabpanel",
    onFocus: function handleFocus() {
      if (hasMouseClickFocus.current) {
        updateMouseFocus(true);
      } else {
        updateMouseFocus(false);
      }

      hasMouseClickFocus.current = false;
    },
    onMouseDown: function handleMouseDown() {
      hasMouseClickFocus.current = true;
    }
  }, rest), children);
};

export { Tab, TabPanel, Tabs };
